import React from 'react';
import styled from "styled-components";
import PriceService from '../../services/PriceService';
import toThousand from '../../services/ToThousandService';
import { useDolarPrice } from '../../hooks/useDolarPrice';

export default function StirrupsUPrices(props){

    const pricesStirrupsU = PriceService.pricesStirrupsU;

    const [dolar, currentDate] = useDolarPrice();
    
    return (
        <StylePrices>

        <div style={{ backgroundColor: 'var(--colorFondoMain)', padding: '20px' }}>
            <div className="scrollPrice container">

                <h2 style={{margin: '1rem 0rem', textAlign: 'center'}}>Tabla de de Estribos en 'U'</h2>

                <div className="contenedorTablaPrecio">
                  
                    {pricesStirrupsU && (
                        <>
                            <table className="tablaPrecio">
                                <thead>
                             
                                <tr className="subTituloPrice">
                                    <td>Imagen</td>
                                    <td>Código</td>
                                    <td>Diámetro</td>
                                    <td>Lado A</td>
                                    <td>Lado B</td>
                                    <td>Cantidad en Empaque</td>
                                    {/* <td className="columnaDolar">Precio U$S + IVA</td>
                                    <td className="columnaPesos">Precio $ + IVA</td> */}
                                </tr>
                                </thead>
                                <tbody>
                                {pricesStirrupsU.map((item, index) => {
                                    const rowClassName = (index % 2 === 0) ? "filaPricePar" : "filaPriceImpar";
                                    return (
                                        <tr key={item.id} className={rowClassName}>
                                        {index === 0 && (
                                            <td rowSpan={pricesStirrupsU.length} style={{ backgroundColor: '#fff' }}>
                                            <img src="/assets/img/stirrups/u.jpg" alt="Estribo en L" style={{ width: '150px', padding: '0.5rem' }} />
                                        </td>
                                        )}
                                        <td>{item.codigo}</td>
                                        <td>{item.mod}</td>
                                        <td>{item.ladoA}</td>
                                        <td>{item.ladoB}</td>
                                        <td>{item.empaque}</td>
                                        {/* <td className="columnaDolar">{toThousand(item.precio)}</td>
                                        <td className="columnaPesos">{toThousand(item.precio * dolar)}</td> */}
                                    </tr>
                                    );
                                })}
                                </tbody>
                            </table>
                        </>
                    )}
                </div>
            </div>
        </div>
        </StylePrices>
    )
}

const StylePrices = styled.div`
    width: 100%;

    .iconScroll{
        display: flex;
        justify-content: center;
        color: var(--colorPrimario);
        @media (min-width: 992px){
            display:none;
        }
    }
    .scrollPrice{
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding-bottom: 2rem;
        @media(min-width: 992px){
            display: flex;
            align-items: center;
        }
    }
    .contenedorTablaPrecio::-webkit-scrollbar{
        height: 15px;
        border-radius: 10px;
        background-color: var(--colorSecundario);
    }
    .contenedorTablaPrecio::-webkit-scrollbar-thumb{
        background-color: var(--colorPrimario);
        border-radius: 10px;
        width: 5px;
    }
    .contenedorTablaPrecio{
        overflow-x: scroll;
        flex-direction: column;
        width: 100%;
        @media (min-width: 992px){
            width: 100%;
            display: flex;
            flex-direction: column ;
            justify-content: space-between;
            margin-top: 2rem;
            ::-webkit-scrollbar {display:none;} //Oculta la barra de scroll sin perder la funcion
        }
    }
    .tablaPrecio{
        margin-top: 0.5rem;
        margin-bottom: 1.5rem;
        width: 100%;
        border-collapse:collapse;
        margin-right: 10px;
        text-align: center;
        @media (min-width: 768px){
            justify-self: flex-end; /* Alinear tabla a la derecha */
        }
    }
    .tituloPrice{
        background-color: var(--colorPrimario);
        margin: 20px;
    }
    .tituloPrice td{
        color: #fff;
        font-family: var(--fuenteSecundaria);
        font-weight: 700;
        font-size: 20px;
        padding: 20px;
    }
    .subTituloPrice{
        background-color: var(--colorGris);
        font-family: var(--fuenteSecundaria);
        color: #fff;
        padding: 5px;
    }
    .subTituloPrice td{
        padding: 10px;
        width: 10%;
        font-weight: 600;
    }
    .filaPricePar {
        background-color: var(--colorFilaTabla);
        font-weight: 500;
    }
    .filaPricePar td{
        padding: 5px;
        font-weight: 500;
    }
    .filaPriceImpar{
        background-color: #fff;
        font-weight: 500;
    }
    .filaPriceImpar td{
        padding: 5px;
        font-weight: 500;
    }
    .columnaDolar{
        background-color: var(--colorTerciario);
        color: #fff;
    }
    .columnaPesos{
        background-color: var(--colorPrimario);
        color: #fff;
    }
    td {
        font-size: 13px;
        @media (min-width: 768px){
            font-size: 15px;
        }
    }
`